<template>
	<div>
		<div class="d-flex align-items-center p-x-20"
		     v-for="(d, i) in data"
		>
			<div class="f-regular f-16 f-c-blue rank m-r-16 d-flex align-items-center">
				#{{ i + 1 }}
			</div>
			<div class="d-flex-between-center align-items-start border-bottom w-100 p-y-16">
				<div class="d-block" style="max-width: 160px">
					<div class="f-semi f-16 f-c-black nomore">{{ d.nama_layanan }}</div>
					<div class="f-regular f-14 f-c-midgrey">Total {{ d.harga_total | currency }}</div>
				</div>
				<div class="d-block text-right">
					<div class="f-regular f-16 f-c-black">{{ formatRupiah(d.jumlah_nota) }} Nota</div>
					<div class="f-regular f-14 f-c-midgrey">
						{{ (d.total_beli.toString().includes(".")) ? d.total_beli.toFixed(2) : d.total_beli }} {{ d.satuan }}
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
export default {
	name: "SOCardCustomerTopFiveLayanan",
	props: ["data"]
}
</script>

<style scoped>
.rank {
	padding: 6px 12px;
	background: #E2F0FF;
	border-radius: 8px;
	height: fit-content;
}
</style>